/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * The global Footer, displays a link to the website and the current Keystone
 * version in use
 */

import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'
import dayjs from 'dayjs'
import useFeatureFlags from 'hooks/useFeatureFlags'

const Footer = () => {
  const flags = useFeatureFlags({ flagNames: ['test_icon_footer'] })?.data
  const showIconFooter = flags?.test_icon_footer?.enabled

  const appVersion = localStorage.getItem('version')

  return (
    <footer className={css(classes.footer)}>
      <div>
        {appVersion?.split('release-')?.[1] || appVersion}
        {showIconFooter && '🏪 '}
      </div>
      <div>{`${dayjs().year()} © LMC Software Ltd. All rights reserved.`}</div>
      <div>
        Registered address: Lion Court, 25 Procter Street, London, WC1V 6NY
      </div>
      <a
        className={css(classes.link)}
        target="_blank"
        href="https://www.logmycare.co.uk/policies/general-data-protection-regulation-gdpr"
        rel="noreferrer"
      >
        Data Policy
      </a>
      |
      <a
        className={css(classes.link)}
        target="_blank"
        href="https://logmycare.co.uk/privacy-policy-carehome"
        rel="noreferrer"
      >
        Privacy Policy
      </a>
      |
      <a
        className={css(classes.link)}
        target="_blank"
        href="https://www.logmycare.co.uk/policies/terms-and-conditions"
        rel="noreferrer"
      >
        Terms & Conditions
      </a>
    </footer>
  )
}

/* eslint quote-props: ["error", "as-needed"] */
const linkHoverAndFocus = {
  color: '#CCC',
  outline: 'none',
}

const classes = StyleSheet.create({
  footer: {
    backgroundColor: '#333',
    color: '#999',
    fontSize: '0.85rem',
    paddingBottom: 25,
    paddingTop: 20,
    textAlign: 'center',
  },
  link: {
    padding: 5,
    color: '#999',
    ':hover': linkHoverAndFocus,
    ':focus': linkHoverAndFocus,
  },
})

export default Footer
